<template>
  <a-row class="filter-layout" type="flex" justify="start" align="top" :gutter="[8, 0]">
    <a-col class="filter-col" :md="this.setMd()">
      <template v-for="col in filterConfig.controls">
        <a-col
          :md="
            filterConfig.controls.length === 1
              ? 5
              : filterConfig.controls.length === 5
              ? 4
              : filterConfig.controls.length >= 6
              ? 4
              : filterConfig.controls.length === 4
              ? 6
              : filterConfig.controls.length === 3
              ? 8
              : 9
          "
          v-if="!col.isToggle"
          :key="col.name"
          class="flex-container"
        >
          <a-range-picker
            v-if="col.type === 'dateRange'"
            :placeholder="dateFormatList"
            :format="dateFormat"
            :style="{ width: '100%' }"
            :value="[
              filters.fromDate ? moment(filters.fromDate) : undefined,
              filters.toDate ? moment(filters.toDate) : undefined,
            ]"
            @change="(e) => onChangeValue(e, col.name, col.type)"
          />
          <a-select
            v-else-if="col.type === 'auto-complete'"
            allowClear
            mode="multiple"
            :placeholder="col.placeholder"
            :style="{ width: '100%' }"
            v-model="filters[col.name]"
            :not-found-content="fetching ? undefined : null"
            :default-active-first-option="false"
            :filter-option="false"
            @search="(value) => onSearch(value, col.name)"
            @change="(e) => onChangeValue(e, col.name, col.type)"
            :maxTagCount="1"
            :dropdownMatchSelectWidth="false"
            :maxTagTextLength="10"
          >
            <a-spin v-if="fetching" slot="notFoundContent" size="small" />
            <template
              v-if="
                col.name === 'employee' ||
                  col.name === 'approver' ||
                  col.name === 'assignee' ||
                  col.name === 'employees' ||
                  col.name === 'creator' ||
                  col.name === 'userList' ||
                  col.name === 'idLdap' ||
                  col.name === 'member'
              "
            >
              <a-select-option
                class="font-size-option-select"
                v-for="item in employeeList"
                :key="item.value"
                :value="item.value"
                >{{ `${item.label} (${item.value} - ${item.department})`}}</a-select-option
              >
            </template>
            <template v-if="col.name === 'projects'">
              <a-select-option
                class="font-size-option-select"
                v-for="item in projectList"
                :key="item.project_id"
                :value="item.project_id"
                >{{ item.project_name }}</a-select-option
              >
            </template>
            <template v-if="col.name === 'employeeId'">
              <a-select-option
                class="font-size-option-select"
                v-for="item in employeeList"
                :key="item.id"
                :value="item.id"
                >{{ item.label + " (" + item.value + " - " + item.department + ")" }}</a-select-option
              >
            </template>
            <template v-if="col.name === 'sf4cId'">
              <a-select-option
                class="font-size-option-select"
                v-for="item in listSF4C"
                :key="item.value"
                :value="item.value"
                >{{ item.label + " (" + item.value + ")" }}</a-select-option
              >
            </template>
            <template v-if="col.name === 'idSdsv'">
              <a-select-option
                class="font-size-option-select"
                v-for="item in listSDSV"
                :key="item.value"
                :value="item.value"
                >{{ item.label + " (" + item.value + ")" }}</a-select-option
              >
            </template>
          </a-select>
          <a-select
            v-else-if="col.type === 'single-select'"
            :allowClear="col.name !== 'payroll_period' && col.name !== 'periodId' && col.name !== 'timesheetId'"
            :mode="col.type === 'default'"
            :showSearch="col.type !== 'multiple-select' ? true : false"
            :placeholder="col.placeholder"
            :style="{ width: '100%' }"
            v-model="filters[col.name]"
            :not-found-content="fetching ? undefined : null"
            @change="(e) => onChangeValue(e, col.name, col.type)"
            :filter-option="filterOption"
            :maxTagCount="1"
          >
            <template v-if="col.name === 'projects'">
              <a-select-option
                class="font-size-option-select"
                v-for="item in projectList"
                :key="item.project_name"
                :value="item.project_id"
                >{{ item.project_name }}</a-select-option
              >
            </template>
          </a-select>
          <a-select
            v-else-if="col.type === 'multiple-select' || col.type === 'select'"
            :allowClear="col.name !== 'payroll_period' && col.name !== 'periodId' && col.name !== 'timesheetId'"
            :mode="col.type === 'multiple-select' ? 'multiple' : ''"
            :showSearch="col.type !== 'multiple-select' ? true : false"
            :placeholder="col.placeholder"
            :style="{ width: '100%' }"
            v-model="filters[col.name]"
            :not-found-content="fetching ? undefined : null"
            @change="(e) => onChangeValue(e, col.name, col.type)"
            :filter-option="filterOption"
            :maxTagCount="1"
            :maxTagTextLength="8"
          >
            <template v-if="col.name === 'department' || col.name === 'departments'">
              <a-select-option
                class="font-size-option-select"
                v-for="item in departmentList"
                :key="item.name"
                :value="item.department_code"
                >{{ item.name }}</a-select-option
              >
            </template>
            <template v-if="col.name === 'otType'">
              <a-select-option
                class="font-size-option-select"
                v-for="item in otTypeList"
                :key="item.type"
                :value="item.type"
                >{{ item.name }}</a-select-option
              >
            </template>
            <template v-if="col.name === 'actual'">
              <a-select-option
                class="font-size-option-select"
                v-for="item in actualTypeList"
                :key="item.code"
                :value="item.code"
                >{{ item.message }}</a-select-option
              >
            </template>
            <!-- <template v-if="col.name === 'projects'">
              <a-select-option
                class="font-size-option-select"
                v-for="item in projectList"
                :key="item.project_name"
                :value="item.project_id"
                >{{ item.project_name }}</a-select-option
              >
            </template> -->
            <template v-if="col.name === 'role'">
              <a-select-option class="font-size-option-select" v-for="item in roleList" :key="item" :value="item">{{
                item
              }}</a-select-option>
            </template>
            <template v-if="col.name === 'reason_type'">
              <a-select-option
                class="font-size-option-select"
                v-for="item in reasonList"
                :key="item.reason_type_code"
                :value="item.reason_type_code"
                >{{ item.reason_type }}</a-select-option
              >
            </template>
            <template v-if="col.name === 'absent_type'">
              <a-select-option
                class="font-size-option-select"
                v-for="item in absentTypesList"
                :key="item.type"
                :value="item.type"
                >{{ item.name }}</a-select-option
              >
            </template>
            <template v-if="col.name === 'status'">
              <a-select-option
                class="font-size-option-select"
                v-for="item in statusTypeList"
                :key="item.type"
                :value="item.type"
                >{{ item.name }}</a-select-option
              >
            </template>
            <template v-if="col.name === 'status-onsite'">
              <a-select-option
                class="font-size-option-select"
                v-for="item in statusTypeList"
                :key="item.type"
                :value="item.type"
                >{{ item.name }}</a-select-option
              >
            </template>

            <template v-if="col.name === 'request_type'">
              <a-select-option
                class="font-size-option-select"
                v-for="(item, index) in requestAbnormalTypeList"
                :key="index"
                :value="item.reason_type_code"
                >{{ item.reason_type }}</a-select-option
              >
            </template>
            <template v-if="col.name === 'location'">
              <a-select-option
                class="font-size-option-select"
                v-for="item in locationList"
                :key="item.code"
                :value="item.name"
                >{{ item.name }}</a-select-option
              >
            </template>
            <template v-if="col.name === 'payroll_period' || col.name === 'timesheetId'">
              <a-select-option
                v-for="item in payrollPeiodList"
                :key="item.timesheet_id"
                :value="item.timesheet_id"
                class="font-size-option-select"
                >{{
                  moment(item.from_date).format("DD/MM/YYYY") + " - " + moment(item.to_date).format("DD/MM/YYYY")
                }}</a-select-option
              >
            </template>
            <template v-if="col.name === 'periodId'">
              <a-select-option
                v-for="item in listPeriodPayroll"
                :key="item.id"
                :value="item.id"
                class="font-size-option-select"
                >{{
                  moment(item.from_date).format("DD/MM/YYYY") + " - " + moment(item.to_date).format("DD/MM/YYYY")
                }}</a-select-option
              >
            </template>
            <template v-if="col.name === 'table'">
              <a-select-option class="font-size-option-select" v-for="item in tableList" :key="item" :value="item">{{
                item
              }}</a-select-option>
            </template>
            <template v-if="col.name === 'requestType'">
              <a-select-option
                class="font-size-option-select"
                v-for="item in requestList"
                :key="item.request_type_code"
                :value="item.request_type_code"
                >{{ item.request_type }}</a-select-option
              >
            </template>
            <template v-if="col.name === 'workScheduleTypes'">
              <a-select-option
                class="font-size-option-select"
                v-for="item in workScheduleTypeList"
                :key="item.code"
                :value="item.code"
                >{{ item.nameVi }}</a-select-option
              >
            </template>
            <template v-if="col.name === 'divisions'">
              <a-select-option
                class="font-size-option-select"
                v-for="item in divisionList"
                :key="item.department_code"
                :value="item.department_code"
                >{{ item.name }}</a-select-option
              >
            </template>
            <template v-if="col.name === 'departmentsFilter'">
              <a-select-option
                class="font-size-option-select"
                v-for="item in departmentFilterList"
                :key="item.department_code"
                :value="item.department_code"
                >{{ item.name }}</a-select-option
              >
            </template>
          </a-select>
          <a-checkbox
            style="margin-top: 7px;"
            v-else-if="col.type === 'checkbox'"
            :checked="filters[col.name]"
            @change="(e) => onChangeValue(e, col.name, col.type)"
            >{{ col.placeholder }}</a-checkbox
          >
        </a-col>
      </template>
    </a-col>
    <a-col class="p0" :md="filterConfig.controls.length >= 6 ? 3 : filterConfig.controls.length < 4 ? 6 : 4">
      <div :class="screen > 700 ? 'ml0' : 'p0'">
        <a-tooltip title="Advanced Search">
          <a-switch
            size="small"
            :class="screen > 700 ? 'mr5' : ' ml10 mt0'"
            v-if="filterConfig.page === 'Timesheet'"
            @change="onChangeSwitch"
          />
        </a-tooltip>
        <a-tooltip title="Search">
          <a-button
            @click="onApplyFilter"
            :class="screen > 700 ? 'mr10' : 'ml10 mr10 mt3'"
            :style="screen > 700 && screen < 900 ? 'width: 28px;height: 28px;padding-left: revert;margin-top: 2px' : ''"
            type="primary"
            :disabled="isDisableBtnSearch"
          >
            <a-icon type="search" />
          </a-button>
        </a-tooltip>
        <a-tooltip title="Reload Search">
          <a-button
            @click="onCleanFilter"
            :style="screen > 700 && screen < 900 ? 'width: 28px;height: 28px;padding-left: revert;margin-top: 2px' : ''"
            :class="screen > 700 ? '' : 'mt3'"
          >
            <a-icon type="reload" />
          </a-button>
        </a-tooltip>
      </div>
    </a-col>
  </a-row>
</template>

<script>
import { mapState } from "vuex";
import { filtersJson, FLEXIBLE_TAB, FIXED_TAB } from "../commons/commonConstant";
import moment from "moment";
import { scaleScreen } from "../commons/commons";
export default {
  name: "FilterLayout",
  props: {
    onSetDataFilters: {
      type: Function,
    },
    onApplyFilters: {
      type: Function,
    },
    currentPage: {
      type: String,
    },
    currentTab: {
      type: String,
    },
    datafilterDefault: {
      type: Object,
    },
  },

  data() {
    return {
      filterConfig: {},
      reasonsTypeList: [],
      visiable: false,
      mdNum: 17,
      statusTypeList: [],
      requestData: [],
      dataSelect: [],
      dateFormatList: ["DD/MM/YYYY", "DD/MM/YYYY"],
      dateFormat: "DD/MM/YYYY",
      fetching: false,
      filters: {
        ...this.datafilterDefault,
      },
      requestAbnormalTypeList: [],
      isDisableBtnSearch: false,
      timeout: null,
      screen: window.outerWidth > 1000 ? window.outerWidth * 0.6 : window.outerWidth * 0.55,
      requestList: [],
      departmentFilterList: [],
    };
  },

  computed: {
    ...mapState({
      requestTypeList: (state) => state.application.requestTypeList,
      payrollPeiodList: (state) => state.application.payrollPeiodList, //tms
      listPeriodPayroll: (state) => state.payroll.listPeriodPayroll, //payroll
      locationList: (state) => state.application.locationList,
      reportStatusList: (state) => state.application.reportStatusList,
      employeeList: (state) => state.application.employeeList,
      absentTypesList: (state) => state.application.absentTypesList,
      statusList: (state) => state.application.statusList,
      reasonTypeList: (state) => state.application.reasonTypeList,
      departmentList: (state) => state.application.departmentList,
      tableList: (state) => state.application.tableList,
      roleList: (state) => state.application.roleList,
      projectList: (state) => state.application.projectList,
      otTypeList: (state) => state.application.otTypeList,
      actualTypeList: (state) => state.abnormalcase.dataActual,
      listSF4C: (state) => state.application.listSF4C,
      listSDSV: (state) => state.application.listSDSV,
      reasonList: (state) => state.application.reasonList,
      workScheduleTypeList: (state) => state.application.workScheduleTypeList,
      divisionList: (state) => state.application.divisionList,
      departmentAllList: (state) => state.application.departmentAllList,
      departmentByDivisionList: (state) => state.application.departmentByDivisionList,
    }),
  },

  watch: {
    filters: function(newFilters) {
      this.onSetDataFilters(newFilters);
      this.setMd();
    },
    currentTab: function(newValue) {
      this.getFiltersJson();
      if (newValue === FLEXIBLE_TAB) {
        this.$store.dispatch("application/getStatusFlexible").then((data) => {
          this.statusTypeList = data;
        });
      } else if (newValue === FIXED_TAB) {
        this.$store.dispatch("application/getStatus").then((data) => {
          this.statusTypeList = data;
        });
      }
    },
  },

  methods: {
    scaleScreen,
    resize() {
      if (document.body.clientWidth > 1000) {
        this.screen = document.body.clientWidth * 0.6;
      } else {
        this.screen = document.body.clientWidth * 0.55;
      }
    },
    moment,
    ////Get config control
    getFiltersJson() {
      let currentPage = this.currentPage;
      let currentTab = this.currentTab;
      let findObj = filtersJson[currentPage];
      if (currentTab && !(currentTab === FIXED_TAB || currentTab === FLEXIBLE_TAB)) {
        findObj = findObj[currentTab];
      }

      if (findObj) {
        this.filterConfig = findObj;
      } else this.filterConfig = {};
    },
    setMd() {
      switch (this.filterConfig.controls.length) {
        case 1:
          this.mdNum = 4;
          break;
        case 2:
          this.mdNum = 10;
          break;
        case 3:
        case 4:
          this.mdNum = 14;
          break;
        case 5:
          this.mdNum = 18;
          break;
        case 6:
        case 7:
        case 9:
          this.mdNum = 21;
          break;
        default:
          break;
      }
      // if(this.filterConfig.page === 'Timesheet'){
      //   this.mdNum = 18
      // }
      return this.mdNum;
    },
    ////handle change value control and set filter obj
    onChangeValue(e, name, type) {
      let value = e;
      let startDateName = "fromDate";
      let endDateName = "toDate";
      if (type === "dateRange") {
        if (this.currentPage === "checkin_checkout" || this.currentPage === "checkin_checkout_by_staff") {
          let startDate = e[0];
          let endDate = e[1];
          let months = endDate.diff(startDate, "months", true);
          if (months > 1) {
            endDate = moment(e[0]).add(1, "month");
          }
          this.filters = {
            ...this.filters,
            [startDateName]: e[0],
            [endDateName]: endDate,
          };
        } else if (this.currentPage === "checkIO_report") {
          let startDate = e[0];
          let endDate = e[1];
          if (e.length > 1) {
            let months = endDate.diff(startDate, "months", true);
            if (months > 3) {
              endDate = moment(e[0]).add(3, "month");
              this.$message.warning("Data Range must not exceed 3 months!", 5);
            }
            this.filters = {
              ...this.filters,
              [startDateName]: startDate,
              [endDateName]: endDate,
            };
          } else {
            this.filters = {
              ...this.filters,
              [startDateName]: undefined,
              [endDateName]: undefined,
            };
          }
        } else {
          this.filters = {
            ...this.filters,
            [startDateName]: e[0],
            [endDateName]: e[1],
          };
        }
      } else {
        if (type === "checkbox") {
          value = e.target.checked;
        }
        if (name === "divisions") {
          if (!value || value?.length <= 0) {
            this.departmentFilterList = this.departmentAllList;
          } else {
            this.$store.commit("application/GET_DEPARTMENT_BY_DIVISION_LIST", value);
            this.departmentFilterList = this.departmentByDivisionList;
            const departmentCodeFilterList = this.departmentFilterList?.map((department) => department.department_code);
            const { departmentsFilter } = this.filters;
            if (departmentsFilter && departmentsFilter?.length > 0) {
              const newDepartmentsFilter = departmentsFilter.filter((departmentCode) =>
                departmentCodeFilterList.includes(departmentCode)
              );
              this.filters.departmentsFilter = newDepartmentsFilter;
            }
          }
        }
        this.filters = {
          ...this.filters,
          [name]: value,
        };
      }
      this.checkDisableBtnSearch();
    },

    checkDisableBtnSearch() {
      const { filters, currentPage } = this;
      if (currentPage === "checkin_checkout" && filters && filters.employee && filters.employee.length > 1) {
        this.isDisableBtnSearch = true;
      } else {
        this.isDisableBtnSearch = false;
      }
      //check disable for TMS Report Check in out page
      if (currentPage === "checkIO_report") {
        this.isDisableBtnSearch = true;
        if (
          filters.fromDate !== undefined &&
          filters.toDate !== undefined &&
          ((filters.projects && filters.projects !== null) ||
            (filters.departments && filters.departments.length > 0) ||
            (filters.userList && filters.userList.length > 0))
        ) {
          this.isDisableBtnSearch = false;
        } else this.isDisableBtnSearch = true;
      }
    },

    /// Apply filter
    onApplyFilter() {
      const { filters } = this;
      this.onApplyFilters(filters);
    },

    buidingUrl(filters) {
      const pathName = this.$route.path;
      let cloneFilter = filters;
      let url = "";
      let params = {};
      Object.keys(cloneFilter).map((it) => {
        let val = cloneFilter[it];
        if (it === "fromDate" || it === "toDate") {
          val = cloneFilter[it] ? moment(cloneFilter[it]).format("YYYY-MM-DD") : undefined;
          // cloneFilter[it] = val;
          params[it] = val;
        }
        if (Array.isArray(val)) {
          if (val.length > 0) {
            params[it] = val;
            url += `${url.length ? "&" : "?"}${it}=${val}`;
          }
        } else if (val) {
          params[it] = val;
          url += `${url.length ? "&" : "?"}${it}=${val}`;
        }
        return it;
      });
      this.$router.push({ path: pathName, query: params }).catch(() => {});
    },

    //// handle clean filter data
    onCleanFilter() {
      const { payrollPeiodList, currentPage, listPeriodPayroll } = this;
      if (currentPage === "checkin_checkout") {
        this.filters = {
          fromDate: moment().startOf("month"),
          toDate: moment().endOf("month"),
        };
      } else if (currentPage === "timesheet" || currentPage === "timesheet_user") {
        if (payrollPeiodList) {
          let findCurrentPeriod = payrollPeiodList.find((item) => item.is_current_timesheet);
          if (findCurrentPeriod) {
            this.filters = {
              payroll_period: findCurrentPeriod.timesheet_id,
            };
          } else {
            this.filters = {};
          }
        } else this.filters = {};
      } else if (currentPage === "payroll_report_detail" || currentPage === "payroll_report_summary") {
        if (payrollPeiodList) {
          let findCurrentPeriod = payrollPeiodList.find((item) => item.is_current_timesheet);
          if (findCurrentPeriod) {
            this.filters = {
              timesheetId: findCurrentPeriod.timesheet_id,
            };
          } else {
            this.filters = {};
          }
        } else this.filters = {};
      } else if (currentPage === "payroll_list" || currentPage === "payslip") {
        if (listPeriodPayroll) {
          let findCurrentPeriodPayroll = listPeriodPayroll.find((item) => item.is_current_timesheet);
          if (findCurrentPeriodPayroll) {
            this.filters = { periodId: findCurrentPeriodPayroll.id };
          } else {
            this.filters = {};
          }
        }
      } else {
        this.filters = {};
      }
      // const pathName = this.$route.path;
      this.checkDisableBtnSearch();
      this.onApplyFilters(this.filters);
      // this.$router.push({ path: pathName });
    },

    /// Get default filters
    getQueryStringSetFilter() {
      let queryStr = this.$route.query;
      let config = this.filterConfig;
      config.controls.map((item) => {
        let type = item.type;
        let name = item.name;
        if (type === "date" && queryStr && queryStr[name]) {
          queryStr[name] = moment(queryStr[name] * 1000);
        }
        if (type === "dateRange" && queryStr) {
          if (queryStr["startDate"]) {
            queryStr.startDate = moment(queryStr["startDate"]);
          } else {
            queryStr.startDate = moment().startOf("month");
          }
          if (queryStr["endDate"]) {
            queryStr.endDate = moment(queryStr["endDate"]);
          } else {
            queryStr.endDate = moment().endOf("month");
          }
        }
        if (type === "checkbox" && queryStr && queryStr[name]) {
          if (queryStr[name] === "true" || queryStr[name] === true) {
            queryStr[name] = true;
          } else queryStr[name] = false;
        }
        if (type === "select" && queryStr && queryStr[name] && !isNaN(queryStr[name])) {
          queryStr[name] = parseInt(queryStr[name]);
        }
        return item;
      });
      this.filters = queryStr;
      this.buidingUrl(queryStr);
    },
    ////On disable start_date and end_date
    onDisableDate(date, name) {
      let filterObj = this.filters;
      if (name === "start_date") {
        if (!date || !filterObj.end_date) return false;
        else if (filterObj.end_date) return date.isAfter(filterObj.end_date, "day");
        else return false;
      }
      if (name === "end_date") {
        if (!date || !filterObj.start_date) return false;
        else if (filterObj.start_date) {
          return date.isBefore(filterObj.start_date, "day");
        } else return false;
      }
    },

    filterOption(input, option) {
      return option.componentOptions.children[0].text.toLowerCase().indexOf(input.toLowerCase()) >= 0;
    },

    async getFilterSelectData() {
      const { filterConfig, filters } = this;
      if (filterConfig) {
        let findControlPeriod = filterConfig.controls.find(
          (item) => item.name === "payroll_period" || item.name === "timesheetId"
        );

        if (findControlPeriod) {
          await this.$store.dispatch("application/getListPayrollPeriodList").then((res) => {
            if (res && res.data) {
              let findCurrentTimesheet = res.data.find((item) => item.is_current_timesheet);
              if (findCurrentTimesheet != undefined) {
                if (findControlPeriod.name === "timesheetId") {
                  this.filters = {
                    ...filters,
                    timesheetId: findCurrentTimesheet.timesheet_id,
                  };
                } else {
                  this.filters = {
                    ...filters,
                    payroll_period: findCurrentTimesheet.timesheet_id,
                  };
                }
              } else {
                this.filters = {
                  ...filters,
                  payroll_period: res.data[0].timesheet_id,
                };
              }
            }
          });
        }
        let findControlPeriodPayroll = filterConfig.controls.find((item) => item.name === "periodId");
        if (findControlPeriodPayroll) {
          await this.$store.dispatch("payroll/getListPayrollPeriod").then((res) => {
            if (res && res.data) {
              let findCurrentPeriodPayroll = res.data.find((item) => item.is_current_timesheet);
              if (findCurrentPeriodPayroll != undefined) {
                this.filters = {
                  ...filters,
                  periodId: findCurrentPeriodPayroll.id,
                };
              } else {
                this.filters = { ...filters, periodId: res.data[0].id };
              }
            }
          });
        }
        filterConfig.controls.map((item) => {
          switch (item.name) {
            case "location":
              this.$store.dispatch("application/getLocationList");
              break;
            case "status":
              if (this.currentTab && this.currentTab === FLEXIBLE_TAB) {
                this.$store.dispatch("application/getStatusFlexible").then((data) => {
                  this.statusTypeList = data;
                });
              } else {
                this.$store.dispatch("application/getStatus").then((res) => {
                  if (res) {
                    if (this.currentPage !== "abnormal_case" && this.currentPage !== "abnormal_case_staff") {
                      res.forEach((element, index) => {
                        if (element.type === 0) {
                          res.splice(index, 1);
                        }
                      });
                    } else {
                      res.forEach((element, index) => {
                        if (element.type === 5) {
                          res.splice(index, 1);
                        }
                      });
                    }
                    this.statusTypeList = res;
                  }
                });
              }

              break;
            case "role":
              this.$store.dispatch("application/getRoleList");
              break;
            case "table":
              this.$store.dispatch("application/getTableList");
              break;
            case "departments":
            case "department":
              this.$store.dispatch("application/getDepartmentList");
              break;
            case "actual":
              this.$store.dispatch("abnormalcase/getParamsDataToSelectActual");
              break;
            case "request_type":
              this.$store.dispatch("application/getReasonTypeList").then((res) => {
                if (res) {
                  let temp = [];
                  res.forEach((element) => {
                    element.reasons.forEach((reason) => {
                      temp.push(reason);
                    });
                  });
                  this.requestAbnormalTypeList = temp;
                }
              });
              break;
            case "absent_type":
              this.$store.dispatch("application/getAbsentList");
              break;
            case "otType":
              this.$store.dispatch("application/getOTTypeList");
              break;
            case "reason_type": {
              let screenType =
                this.currentPage === "request_management" || this.currentPage === "request_management_by_staff"
                  ? "Request"
                  : "";
              this.$store.dispatch("application/getReasonListByScreen", screenType);
              break;
            }
            case "requestType": {
              this.$store.dispatch("request/getParamsDataToSelect", { screenType: "Request" }).then((res) => {
                const { request_reason } = res.data;
                if (request_reason) {
                  this.requestList = request_reason;
                } else {
                  this.requestList = [];
                }
              });
              break;
            }
            case "workScheduleTypes": {
              this.$store.dispatch("application/getWorkScheduleTypeList");
              break;
            }
            case "divisions": {
              this.$store.dispatch("application/getDivisionList").then(() => {
                const { divisions } = this.filters;
                if (divisions && divisions?.length > 0) {
                  this.$store.commit("application/GET_DEPARTMENT_BY_DIVISION_LIST", divisions);
                  this.departmentFilterList = this.departmentByDivisionList;
                } else {
                  this.departmentFilterList = this.departmentAllList;
                }
              });
              break;
            }
          }
          return item;
        });
      }
    },
    onChangeSwitch(checked) {
      this.filterConfig.controls.forEach((item) => {
        if (item.isToggle != undefined) {
          this.filters[item.name] = [];
          item.isToggle = !checked;
        }
      });
    },
    onSearch(value, name) {
      let cloneVal = decodeURI(value);
      if (value && value !== "" && value.length >= 3) {
        if (
          name === "employee" ||
          name === "approver" ||
          name === "assignee" ||
          name === "userList" ||
          name === "employeeId" ||
          name === "employees" ||
          name === "member" ||
          name === "idLdap"
        ) {
          this.fetching = true;
          clearTimeout(this.timeout);
          this.timeout = setTimeout(() => {
            this.$store
              .dispatch("application/getEmployeeList", cloneVal)
              .then(() => {
                this.fetching = false;
              })
              .catch(() => {
                this.fetching = false;
              });
          }, 1000);
        }
        if (name === "projects") {
          this.fetching = true;
          clearTimeout(this.timeout);
          this.timeout = setTimeout(() => {
            this.$store
              .dispatch("application/getProjectList", value)
              .then(() => {
                this.fetching = false;
              })
              .catch(() => {
                this.fetching = false;
              });
          }, 1000);
        }
        if (name === "idSdsv") {
          this.fetching = true;
          clearTimeout(this.timeout);
          this.timeout = setTimeout(() => {
            this.$store
              .dispatch("application/getEmployeeSDSV", cloneVal)
              .then(() => {
                this.fetching = false;
              })
              .catch(() => {
                this.fetching = false;
              });
          }, 1000);
        }
        if (name === "sf4cId") {
          this.fetching = true;
          clearTimeout(this.timeout);
          this.timeout = setTimeout(() => {
            this.$store
              .dispatch("application/getListSF4C", cloneVal)
              .then(() => {
                this.fetching = false;
              })
              .catch(() => {
                this.fetching = false;
              });
          }, 1000);
        }
      }
    },
  },
  created() {
    this.scaleScreen(), window.addEventListener("resize", this.resize);
    this.getFiltersJson();
    sessionStorage.setItem(
      this.filterConfig.page,
      JSON.stringify({
        page: 1,
        size: 10,
      })
    );
  },

  async mounted() {
    const paramTimesheetId = this.$route.query.timesheetid;
    await this.getFilterSelectData();
    if (paramTimesheetId) {
      this.filters.payroll_period = paramTimesheetId;
    }
    this.onChangeSwitch(false);
    this.onApplyFilters(this.filters);
    this.checkDisableBtnSearch();
  },
};
</script>
<style></style>
